import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';

import { BlockUiService } from '../../core/libs/shared/components/block-ui/block-ui.service';
import { ApiResponse } from '../../core/models/api-response.model';
import { SurveyService } from '../../core/services/api/survey.service';
import { SurveyDataService } from '../../core/services/survey-data.service';
import { ErrorService } from '../../core/services/error.service';
import { SurveyChoicesModelInterface } from '../../features/user-personalization-survey/user-personalization-survey.model';

@Component({
    selector: 'app-survey-layout',
    templateUrl: './survey-layout.component.html',
    styleUrl: './survey-layout.component.scss',
})
export class SurveyLayoutComponent {
    private readonly CACHE_KEY = 'user-personalization-survey';
    private isSubmitting: boolean = false;

    constructor(
        private router: Router,
        private surveyService: SurveyService,
        private surveyDataService: SurveyDataService,
        private errorService: ErrorService,
        private blockUiService: BlockUiService
    ) {}

    protected skipSurvey() {
        if (this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;
        this.blockUiService.open();

        // Get current survey data from service or fallback to empty data if not available
        const surveyDataToSubmit = this.surveyDataService.getSurveyData() || {
            programCategories: [],
            preferredLanguages: [],
            preferredLanguageDisplayTexts: [],
            programTypeNames: [],
            goals: []
        };
        
        // Option 1: Skipping will not save any user's selections into DB.
        const userSurveyDataToSubmit = {
            programCategories: [],
            preferredLanguages: [],
            preferredLanguageDisplayTexts: [],
            programTypeNames: [],
            goals: []
        };

        // Option 2: Skipping still saves user's selections prior to skip action into DB.
        // const userSurveyDataToSubmit = this.surveyDataService.getUserSurveyData() || {
        //     programCategories: [],
        //     preferredLanguages: [],
        //     preferredLanguageDisplayTexts: [],
        //     programTypeNames: [],
        //     goals: []
        // };

        // Submit current user survey data with markAsComplete = true
        this.surveyService
            .submitSurvey(surveyDataToSubmit, userSurveyDataToSubmit, true)
            .pipe(
                finalize(() => {
                    this.isSubmitting = false;
                    this.blockUiService.close();
                })
            )
            .subscribe({
                next: (response: ApiResponse<boolean>) => {
                    // Clear cache after successful submission
                    this.clearCache();
                },
                error: (error: any) => {
                    this.errorService.showError(error);
                }
            });
    }
    
    private clearCache(): void {
        try {
            localStorage.removeItem(this.CACHE_KEY);

            // Debug Log Tracker (Front-End)
            // console.log('[On Submit Survey|Cache] Cache cleared');
        }
        catch (error) {
            // Debug Log Tracker (Front-End)
            // console.warn('[On Submit Survey|Cache] Failed to clear cache:', error);
        }
        finally {
            this.router.navigate(['/home']);
        }
    }
}
